module.exports = __webpack_public_path__ + "static/media/s5-2.dafc9142.png";